export default __webpack_public_path__ + "static/media/Acusan-Plus-ban.7ed05cfa.jpg";